/** @jsxImportSource @emotion/react */

import PropTypes from 'prop-types'

/**
 * Home icon component - displays a home/house SVG icon
 */
const HomeIcon = ({ width = 12, height = 12, fill = '#C1C2C3', ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      {...props}
    >
      <path
        d='M1.99935 10.6668H3.99935V6.66683H7.99935V10.6668H9.99935V4.66683L5.99935 1.66683L1.99935 4.66683V10.6668ZM1.99935 12.0002C1.63268 12.0002 1.3189 11.8697 1.05802 11.6088C0.796682 11.3475 0.666016 11.0335 0.666016 10.6668V4.66683C0.666016 4.45572 0.713349 4.25572 0.808016 4.06683C0.902238 3.87794 1.03268 3.72238 1.19935 3.60016L5.19935 0.600163C5.32157 0.511274 5.44935 0.444607 5.58268 0.400163C5.71602 0.355718 5.8549 0.333496 5.99935 0.333496C6.14379 0.333496 6.28268 0.355718 6.41602 0.400163C6.54935 0.444607 6.67713 0.511274 6.79935 0.600163L10.7993 3.60016C10.966 3.72238 11.0967 3.87794 11.1913 4.06683C11.2856 4.25572 11.3327 4.45572 11.3327 4.66683V10.6668C11.3327 11.0335 11.2022 11.3475 10.9413 11.6088C10.68 11.8697 10.366 12.0002 9.99935 12.0002H6.66602V8.00016H5.33268V12.0002H1.99935Z'
        fill={fill}
      />
    </svg>
  )
}

HomeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default HomeIcon
